const systemRouter = [
  {
    path: '/v10main',
    name: 'v10main',
    component: () => import('@/layout/main/V10Main.vue'),
    meta: { title: 'Main', affix: false },
    children: [
      {
        path: ':pgmId(.*)', // Dynamic parameter for program ID
        name: 'program', // Name of the route
        component: (route) => import(`@/views/mis${route.params.pgmId}.vue`),  // Dynamic import based on pgmId
        meta: {
          menu_code: 'program',
          title: 'Program View',
          affix: false,
        }
      }
    ]
  }
]

export default systemRouter;
